/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

export type EntityTenantSettingsLinks = io.TypeOf<typeof TenantSettingsLinks>;

export const TenantSettingsLinks = io.type({
  next: io.union([io.string, io.null]),
  prev: io.union([io.string, io.null]),
});
